import { getRechargeOrderList } from '@/api/dashboard/dashboard';
// import initFiltersStore from '@/store/modules/filters';
import { getFilters, formatDate } from '@/utils';
const FETCH_RECHARGE_LIST = 'FETCH_RECHARGE_LIST';
const FETCH_DATA = 'FETCH_DATA';

// const initFilters = () => ({
//   operateId: undefined,
//   areaId: undefined,
//   timeType: 0, // 0 本日，1 本月， 2 本年
// });
// const filtersStore = initFiltersStore(initFilters);
const nowTime = new Date();

const state = () => ({
  loading: false,
  list: [],
  rechargeOrderCountVo: {
    rechargeMen: 0,
    rechargeMoney: 0,
  },
});

const getters = {
  rechargeList: state => state.list,
  rechargeCount: state => state.rechargeOrderCountVo,
  loading: state => state.loading,
};

const actions = {
  getRechargeOrderList({ commit, rootGetters }) {
    commit(FETCH_DATA, true);
    let entity = getFilters(rootGetters['Dashboard/customerData/filters']);
    switch (entity.timeType) {
      case 1:
        entity.month = formatDate(nowTime, 'yyyy-MM');
        break;
      case 2:
        entity.year = formatDate(nowTime, 'yyyy');
        break;
      case 0:
      default:
        entity.date = formatDate(nowTime, 'yyyy-MM-dd');
        break;
    }
    return getRechargeOrderList({
      data: entity,
    })
      .then(res => {
        const { data, rechargeOrderCountVo } = res;
        commit(FETCH_DATA, false);
        commit(FETCH_RECHARGE_LIST, { list: data, rechargeOrderCountVo });
      })
      .catch(err => {
        console.error(err);
        commit(FETCH_DATA, false);
      });
  },
};

const mutations = {
  [FETCH_RECHARGE_LIST](state, data) {
    state.list = data.list;
    state.rechargeOrderCountVo = data.rechargeOrderCountVo;
  },
  [FETCH_DATA](state, fetching) {
    state.loading = fetching;
  },
};

export default {
  namespaced: true,
  // modules: { filtersStore },
  state,
  getters,
  actions,
  mutations,
};
